import { type Editor } from 'slate';

// Allow storing additional state variables on an editor instance without
// polluting the actual editor object. This follows the same pattern
// as the `HistoryEditor` class in Slate, but uses a single WeakMap per editor
// instead of a separate WeakMap per variable.

const STATE = new WeakMap<Editor, any>();

export enum Namespace {
  AhaEditor = 'ahaEditor',
  History = 'history',
  Transcripts = 'transcripts',
}

export enum AhaEditorKey {
  // The instance of AhaEditor that contains this editor.
  Instance = 'instance',
}

export enum HistoryKey {
  Instance = 'instance',
  Saving = 'savingUndo',
  Transforming = 'transformUndo',
  Merging = 'mergeUndo',
}

export enum TranscriptsKey {
  // The speaker information for the current transcript.
  SpeakerInfo = 'speakerInfo',
}

type EditorStateKey = AhaEditorKey | HistoryKey | TranscriptsKey;

const EditorState = {
  set(editor: Editor, namespace: Namespace, key: EditorStateKey, value: any) {
    let state = STATE.get(editor);
    if (!state) {
      state = {};
      STATE.set(editor, state);
    }
    state[namespace] = state[namespace] || {};
    state[namespace][key] = value;
  },

  get(editor: Editor, namespace: Namespace, key: EditorStateKey) {
    const state = STATE.get(editor);
    if (
      state &&
      Object.hasOwn(state, namespace) &&
      Object.hasOwn(state[namespace], key)
    ) {
      return state[namespace][key];
    } else {
      return undefined;
    }
  },
};

export default EditorState;
